var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalibrationDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27422 0C3.71378 0 0 3.71378 0 8.27422C0 12.8347 3.71378 16.5484 8.27422 16.5484C12.8347 16.5484 16.5484 12.8347 16.5484 8.27422C16.5484 3.71378 12.8347 0 8.27422 0ZM12.1227 6.77331L7.50452 11.3915C7.35058 11.5454 7.15816 11.6224 6.96574 11.6224C6.77331 11.6224 6.58089 11.5454 6.42695 11.3915L4.0409 9.04391C3.73302 8.73604 3.73302 8.25498 4.0409 7.9471C4.34878 7.63922 4.82983 7.63922 5.13771 7.9471L6.94649 9.75588L11.0259 5.6765C11.3338 5.36862 11.8148 5.36862 12.1227 5.6765C12.4113 5.98438 12.4113 6.46544 12.1227 6.77331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibrationDoneIcon);
export default __webpack_public_path__ + "static/media/calibration_done_icon.5328fede32f8198eff765a8cfaa33a78.svg";
export { ForwardRef as ReactComponent };